import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'provider': 'onClick', } };
    }
    onClick( e ){
        this.el.querySelector( '[data-plugin="nsl"][data-provider="' + e.target.dataset.provider + '"]').click();
    }
}
